/* */ 
(function(Buffer) {
  'use strict';
  var Promise = require('../util/promise'),
      YAML = require('../util/yaml');
  module.exports = {
    order: 200,
    allowEmpty: true,
    canParse: ['.yaml', '.yml', '.json'],
    parse: function parseYAML(file) {
      return new Promise(function(resolve, reject) {
        var data = file.data;
        if (Buffer.isBuffer(data)) {
          data = data.toString();
        }
        if (typeof data === 'string') {
          resolve(YAML.parse(data));
        } else {
          resolve(data);
        }
      });
    }
  };
})(require('buffer').Buffer);
